export default __webpack_public_path__ + "static/media/eth.f828434d.mp4";